/* eslint-disable @nx/enforce-module-boundaries */
import { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { canActivateFn, canMatchFn } from '@kanzi-apes/kanzi-auth';
import { LayoutMainViewComponent } from './components/layout-main-view/layout-main-view.component';
import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as LocationState from '@kanzi-apes/kanzi-location';
import * as CustomerState from '@kanzi-apes/kanzi-customer';

const kanziTitle = 'Kanzi Box Validator';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    providers: [
      importProvidersFrom(
        StoreModule.forFeature(
          LocationState.LOCATIONS_FEATURE_KEY,
          LocationState.locationsReducer
        )
      ),
      importProvidersFrom(
        StoreModule.forFeature('customer', CustomerState.reducers)
      ),
    ],
    title: kanziTitle,
    data: {
      breadcrumb: 'menu_breadcrumb.home',
    },
    canActivate: [canActivateFn],
    children: [
      {
        path: '',
        component: LayoutMainViewComponent,
      },
      {
        path: 'products',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-products').then(
            (m) => m.kanziProductsRfidRoutes
          ),
        title: kanziTitle + ' - Products',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.products',
        },
        providers: [],
      },
      {
        path: 'packings',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-logistic-packing').then(
            (m) => m.KanziLogisticPackingModule
          ),
        title: kanziTitle + ' - Packings',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.packings',
        },
      },
      {
        path: 'locations',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-location').then(
            (m) => m.KanziLocationModule
          ),
        title: kanziTitle + ' - Locations',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.locations',
        },
      },
      {
        path: 'users',
        loadChildren: () =>
          import('@kanzi-apes/kanzi-users').then((m) => m.usersRoutes),
        title: kanziTitle + ' - Users',
        canMatch: [canMatchFn],
        data: {
          breadcrumb: 'menu_breadcrumb.users',
        },
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@kanzi-apes/kanzi-auth').then((m) => m.kanziAuthRfidRoutes),
    title: kanziTitle + ' - Login',
    providers: [],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
